import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostListAgent(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostListAgentPage(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/pagelist`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostCountAgentPage(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetAgent(id, params) {
  return request(`${BASE_URL}/provider/ams/agent/h5/${id}`, METHOD.GET, params)
}

export async function rqtPostAgentSave(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/saveall`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostAgentWmsList(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/wms/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostDepartmentLeaderList(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/department/leader/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostAgentAssessList(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/assess/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetAgentAssessAssetProduct(id, params) {
  return request(
    `${BASE_URL}/provider/ams/agent/assess/${id}/asset/product`,
    METHOD.GET,
    params
  )
}

export async function rqtGetAgentAssessAssetInsOrder(id, params) {
  return request(
    `${BASE_URL}/provider/ams/agent/assess/${id}/asset/insorder`,
    METHOD.GET,
    params
  )
}

export async function rqtGetAgentAssessAssetEquityInsProduct(id, params) {
  return request(
    `${BASE_URL}/provider/ams/agent/assess/${id}/asset/equityins/product`,
    METHOD.GET,
    params
  )
}

export async function rqtPostAgentExportAssessList(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/export/assess/list`,
    METHOD.POST_JSON_ENCRYPT,
    params,
    { responseType: 'blob', timeout: 600000 }
  )
}

export async function rqtPostAgentAssessDepartmentList(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/assess/department/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetAgentAssessAssetDepartmentProduct(id, params) {
  return request(
    `${BASE_URL}/provider/ams/agent/assess/${id}/asset/department/product`,
    METHOD.GET,
    params
  )
}

export async function rqtGetAgentAssessAssetDepartmentInsOrder(id, params) {
  return request(
    `${BASE_URL}/provider/ams/agent/assess/${id}/asset/department/insorder`,
    METHOD.GET,
    params
  )
}

export async function rqtGetAgentAssessAssetDepartmentEquityInsProduct(
  id,
  params
) {
  return request(
    `${BASE_URL}/provider/ams/agent/assess/${id}/asset/department/equityins/product`,
    METHOD.GET,
    params
  )
}

export async function rqtPostAgentExportAssessDepartmentList(params) {
  return request(
    `${BASE_URL}/provider/ams/agent/export/assess/department/list`,
    METHOD.POST_JSON_ENCRYPT,
    params,
    { responseType: 'blob', timeout: 600000 }
  )
}
